var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { dia } from '@joint/plus';
var AnimatedElementView = /** @class */ (function (_super) {
    __extends(AnimatedElementView, _super);
    function AnimatedElementView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimatedElementView.prototype.updateTransformation = function () {
        var _a = this, el = _a.el, model = _a.model;
        var _b = model.get('position'), x = _b.x, y = _b.y;
        var transform = "translate(".concat(x, "px, ").concat(y, "px)");
        var keyframes = { transform: [transform] };
        var move;
        if (this.move) {
            move = this.move;
            move.effect.setKeyframes(keyframes);
            move.currentTime = 0;
            move.play();
        }
        else {
            move = el.animate(keyframes, {
                easing: 'ease-in',
                fill: 'forwards',
                duration: 200
            });
            move.onfinish = function () { return el.parentNode && move.commitStyles(); };
            move.finish();
            this.move = move;
        }
    };
    return AnimatedElementView;
}(dia.ElementView));
export { AnimatedElementView };
